<template>
  <el-select
    :value="value"
    clearable
    filterable
    @input="$emit('input', $event)"
    :disabled="!isSelectEmployee"
  >
    <el-option
      v-for="(item, index) in options"
      :key="getOptionKey(item, index)"
      :label="getOptionLabel(item)"
      :value="getOptionValue(item)"
    ></el-option>
  </el-select>
</template>

<script>
export default {
  name: 'DirectManagerField',
  props: {
    value: {
      type: [String, Number],
      default: undefined,
    },
    options: {
      type: Array,
      default: () => [],
    },
    labelBuilder: {
      type: Function,
      default: null,
    },
  },
  methods: {
    getEmployee(option) {
      return option && option.e ? option.e : option;
    },
    getOptionKey(option, index) {
      const employee = this.getEmployee(option);
      return employee && employee.id ? employee.id : index;
    },
    getOptionValue(option) {
      const employee = this.getEmployee(option);
      return employee && employee.id ? employee.id : '';
    },
    getOptionLabel(option) {
      const employee = this.getEmployee(option);
      if (!employee) return 'khong xac dinh';
      if (this.labelBuilder) {
        return this.labelBuilder(employee);
      }

      const fullName =
        employee.name ||
        employee.full_name ||
        (employee.administrative_info &&
        employee.administrative_info.name &&
        employee.administrative_info.name.full_name
          ? employee.administrative_info.name.full_name
          : '');

      if (!fullName && !employee.employee_no) {
        return 'khong xac dinh';
      }

      return employee.employee_no
        ? `${employee.employee_no} - ${fullName || ''}`
        : fullName || 'khong xac dinh';
    },
  },
}
</script>
